import { useState } from 'react'

import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import { getImageDirectUploadData } from '../utils/getImageDirectUploadData'
import { useConfirmImageResourceMutation } from './useConfirmImageResourceMutation'
import { useCreateImageResourceMutation } from './useCreateImageResourceMutation'
import { useUploadImageMutation } from './useUploadImageMutation'

type Image = { url: string; resizedUrl: string; id: number }

type Props = {
  files: File[]
  onSuccess: (images: Image[]) => void
}

export const useCreateImageResources = () => {
  const [isLoading, setIsLoading] = useState(false)

  const { createImageResourceMutation } = useCreateImageResourceMutation()
  const { uploadImageMutation } = useUploadImageMutation()
  const { confirmImageResourceMutation } = useConfirmImageResourceMutation()

  const createImageResources = async ({ files, onSuccess }: Props) => {
    const imageResources: Image[] = []

    setIsLoading(true)

    await Promise.all(
      files.map(async (file) => {
        try {
          const payload = await getImageDirectUploadData(file)

          const { uploadData, resourceId } = await createImageResourceMutation.mutateAsync([
            { ...payload },
          ])

          await uploadImageMutation.mutateAsync([
            file,
            {
              headers: uploadData.headers,
              uploadUrl: uploadData.url,
            },
          ])

          await confirmImageResourceMutation.mutateAsync([
            resourceId,
            { signedId: uploadData.signedId },
          ])

          const { data } = await MembershipsCreatorApiClient.getResources({
            'ids[]': [resourceId],
          })

          imageResources.push({
            url: data.resources[0].url,
            resizedUrl: data.resources[0].resizedUrl,
            id: resourceId,
          })
        } catch {}
      }),
    )

    setIsLoading(false)
    onSuccess(imageResources)
  }

  return {
    createImageResources,
    isLoading,
  }
}
